/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface OrderSubsegmentationChoiceReadAttributes
 */
export interface OrderSubsegmentationChoiceReadAttributes {
    /**
     * 
     * @type {Date}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    segmentationType: OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    updatedAt?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum {
    CONGRESS = 'CONGRESS',
    GROUPTRAVEL = 'GROUP_TRAVEL',
    INCENTIVES = 'INCENTIVES',
    MEETINGORCONFERENCE = 'MEETING_OR_CONFERENCE',
    SOCIALEVENT = 'SOCIAL_EVENT',
    WEDDING = 'WEDDING'
}

